import { z } from 'zod'

export const supplierInstallationEmissionReportYearValues = [2026, 2027] as const

export type SupplierInstallationEmissionReportYear =
  (typeof supplierInstallationEmissionReportYearValues)[number]

export const supplierInstallationEmissionReportYearSchema = z.union([
  z.literal(2026),
  z.literal(2027),
])
